/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//   jQuery(document).ready(function(){

    $('.product-order-type-selector').find('li').each(function() {
      //alert($('input[type="radio"]:checked'). val());
      if ($(this).hasClass('active')){
        $(this).find('input[type="radio"]').prop("checked", true);        
      }else{
        $(this).find('input[type="radio"]').prop("checked", false);
      }
      // $(this).find('.product-order-type-qty').find('input').val('0');
      $(this).find('input[type="radio"]').click(function(){
        var pack_size = $(this).attr("data-pk")
        // var parentActive = $(this).closest("li");
        // if (parentActive.hasClass("active")) {
        //   alert("if");
        // } else {
        //   alert("else");
        // }
        $(".pdp-prop").val(pack_size);
        $(this).parents('.product-order-type-selector').find('li').removeClass('active');
        //$(this).parents('.product-order-type-selector').find('li').find('.product-order-type-qty').addClass('hide');
        $(this).parents('.product-order-type-selector').find('li').find('.product-item__action-button').addClass('hide');
        $(this).parents('.product-order-type-selector').find('li').find('input[type="radio"]').prop("checked", false);
        $(this).parents('li').addClass('active');   
        //$(this).parents('li').find('.product-order-type-qty').removeClass('hide');
        $(this).parents('li').find('.product-item__action-button').removeClass('hide');
        $(this).prop("checked", true);


        var currentVal = parseInt($(this).parents('li').find('.product-order-type-qty').find('input[type="number"]').val());
        var stepup = $(this).parents('li').find('.product-order-type-qty').data('step');
        // alert(stepup);      
        var finalqty = $(this).parents('li').find('.product-order-type-qty').data('finalqty');
      	var colprice = $(this).parents('.product-order-type-selector').find('li').find('.piece-price').find('span').html();
        //var colprice = $(this).closest('.price-list').html();
        //alert(colprice);
        var colpprice = colprice.replace(/[_\W]+/g, "");
        //var colqty = currentVal + stepup;		
        var colfqty = currentVal * finalqty;        
        var totalprice = (colfqty*colpprice)/100;
        var convertprice = totalprice.toFixed(2);  
        var addsymbole = '$' + convertprice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        //alert($(this).parents('.product-order-type-selector').parent('form').find('.grid-form-col').html());        
        //$(this).parents('.product-order-type-selector').parent('.grid-form-col').parent('form').find('.grid-form-col').find('.col-qty').val(colfqty); 
        $(this).parents('.product-order-type-selector').parent('.grid-form-col').parent('form').find('.col-qty').val(colfqty); 
        $(this).parents('.product-order-type-selector').find('.piece-qty').html(colfqty);
        $(this).parents('.product-order-type-selector').find('.piece-total').html(addsymbole);
      });
    });
//     //$(this).find('.product-item__info').find('from').removeClass('tooltips-open');


//     $('.mobile-tooltips').on('click touchstart',function(){  
//       //$(this).parent('.product-item__info').parent('.product-item').parent('.product-list').find('form').removeClass('tooltips-open');
//       if($(this).next('form').hasClass('tooltips-open')){
//         $('.product-item__info').find('form').removeClass('tooltips-open');        
//       }else{        
//         $('.product-item__info').find('form').removeClass('tooltips-open');
//         $(this).next('form').addClass('tooltips-open');
//       }
//       //$(this).next('form').addClass('tooltips-open');

//     });
    // This button will increment the value
    $('.qtyplus').click(function(e){    	
      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = $(this).attr('field');
      //alert()
      // Get its current value
      var currentVal = parseInt($(this).parent('.product-order-type-qty').find('input[name='+fieldName+']').val());
      var stepup = $(this).parent('.product-order-type-qty').data('step'); 
      var minvalue = $(this).parent('.product-order-type-qty').data('minvalue');
      var finalqty = $(this).parent('.product-order-type-qty').data('finalqty');
      var colprice = $(this).parents('.product-order-type-selector').find('li').find('.piece-price').data('colpprice');
      var colpprice = colprice.replace(/[_\W]+/g, "");
      
      // if(typeof BOLD === "object" && typeof BOLD.pre === "object" && typeof BOLD.pre.getProductByVariantId === "function"){
      //   var prodId = parseInt(this.form.id.value);
      //   var product = BOLD.pre.getProductByVariantId(prodId);
      //   if(product)
      //     var colpprice = product.price;
      // }

      var colqty = currentVal + stepup;
      var colfqty = colqty * finalqty;
      var totalprice = (colfqty*colpprice)/100;
      
      var convertprice = totalprice.toFixed(2);  
      var addsymbole = '$' + convertprice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // If is not undefined
      if (!isNaN(currentVal)) {
        // Increment    
        var totalqty = finalqty * ( currentVal + stepup );
        $(this).parents('.product-order-type-selector').find('.piece-qty').html(totalqty);
        $(this).parents('.product-order-type-selector').find('.piece-total').html(addsymbole);        
        $(this).parents('.product-order-type-selector').parent('.grid-form-col').parents('form').find('.col-qty').val(totalqty);          
        $(this).parent('.product-order-type-qty').find('input[name='+fieldName+']').val(currentVal + stepup);
      } else {
        // Otherwise put a 0 there
        $(this).parents('.product-order-type-selector').find('.piece-qty').html(minvalue);
        $(this).parents('.product-order-type-selector').find('.piece-total').html(addsymbole);        
        $(this).parents('.product-order-type-selector').parent('.grid-form-col').parents('form').find('.col-qty').val(minvalue);          
        $(this).parent('.product-order-type-qty').find('input[name='+fieldName+']').val(minvalue);
      }
    });
    // This button will decrement the value till 0
    $(".qtyminus").click(function(e) {
      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = $(this).attr('field');
      // Get its current value
      var currentVal = parseInt($(this).parent('.product-order-type-qty').find('input[name='+fieldName+']').val());
      var stepdown = $(this).parent('.product-order-type-qty').data('step'); 
      var minvalue = $(this).parent('.product-order-type-qty').data('minvalue');
      var finalqty = $(this).parent('.product-order-type-qty').data('finalqty');
      var currentval1 = currentVal - minvalue;
      var colprice = $(this).parents('.product-order-type-selector').find('.piece-price').data('colpprice');
      var colpprice = colprice.replace(/[_\W]+/g, "");
      //var colqty = currentVal + stepup;

      if(typeof BOLD === "object" && typeof BOLD.pre === "object" && typeof BOLD.pre.getProductByVariantId === "function"){
        var prodId = parseInt(this.form.id.value);
        var product = BOLD.pre.getProductByVariantId(prodId);
        if(product)
          var colpprice = product.price;
      }
      
      if (currentval1 > 0) {
        var colfqty = currentval1 * finalqty;   
      }else if(currentval1 < minvalue){
        var colfqty = currentVal * finalqty; 
      }else{
        var colfqty = currentVal * finalqty; 
      }
      var totalprice = (colfqty*colpprice)/100;
      var convertprice = totalprice.toFixed(2);  
      var addsymbole = '$' + convertprice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // If it isn't undefined or its greater than 0
      if (currentval1 > 0) {
        // Decrement one          
        var totalqty = finalqty * ( currentVal - stepdown );
        $(this).parents('.product-order-type-selector').find('.piece-qty').html(totalqty);
        $(this).parents('.product-order-type-selector').find('.piece-total').html(addsymbole);       
        $(this).parents('.product-order-type-selector').parent('.grid-form-col').parents('form').find('.col-qty').val(totalqty);
        $(this).parent('.product-order-type-qty').find('input[name='+fieldName+']').val(currentVal - stepdown);
      }else if(currentval1 < minvalue){
        $(this).parents('.product-order-type-selector').find('.piece-qty').html(totalqty);
        $(this).parents('.product-order-type-selector').find('.piece-total').html(addsymbole);        
        $(this).parents('.product-order-type-selector').parent('.grid-form-col').parent('form').find('.col-qty').val(minvalue);
        $(this).parent('.product-order-type-qty').find('input[name='+fieldName+']').val(minvalue);
      }else {          
        // Otherwise put a 0 there
        $(this).parents('.product-order-type-selector').find('.piece-qty').html(totalqty);
        $(this).parents('.product-order-type-selector').find('.piece-total').html(addsymbole);
        $(this).parents('.product-order-type-selector').find('.piece-qty').html(minvalue);        
        $(this).parents('.product-order-type-selector').parent('.grid-form-col').parents('form').find('.col-qty').val(minvalue);
        $(this).parent('.product-order-type-qty').find('input[name='+fieldName+']').val(minvalue);
      }
    });
//     //  $(".qty_input").on("change keyup",function(){var t=$(this).parent("form").parent(".table-qty").parent(".table-data").data("usize")*$(this).val();$(this).parent("form").find(".col-qty").val(t),$(this).parent("form").parent(".table-qty").parent(".table-data").find(".table-tunite").html(t);var a="$"+(t*$(this).parent("form").parent(".table-qty").parent(".table-data").data("colpprice").replace(/[_\W]+/g,"")/100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,",");$(this).parent("form").parent(".table-qty").parent(".table-data").find(".table-totle").html(a)});

 $('.qty_input').on('change keyup', function() {
      var usize = $(this).parent('form').parent('.table-qty').parent('.table-data').data('usize');
      var cqty = $(this).val();
      var total_qty = usize * cqty;      
      $(this).parent('form').find('.col-qty').val(total_qty);
      $(this).parent('form').parent('.table-qty').parent('.table-data').find('.table-tunite').html(total_qty);
      var colprice = $(this).parent('form').parent('.table-qty').parent('.table-data').find('.table-uprice').find('span').html();      
      var colpprice = colprice.replace(/[_\W]+/g, "");
      var totalprice = (total_qty*colpprice)/100;
      var convertprice = totalprice.toFixed(2);  
      var addsymbole = '$' + convertprice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");      
      $(this).parent('form').parent('.table-qty').parent('.table-data').find('.piece-total').html(addsymbole);    
      //alert(convertprice);
    });
   // Reusable Function to Enforce MaxLength
function enforce_maxlength(event) {
  var t = event.target;
  if (t.hasAttribute('maxlength')) {
    t.value = t.value.slice(0, t.getAttribute('maxlength'));
  }
}

// Global Listener for anything with an maxlength attribute.
// I put the listener on the body, put it on whatever.
document.body.addEventListener('input', enforce_maxlength);
    function processProductItemsTable() {
  $(".mini-cart__line-item-list")
    .find(".mini-cart__line-item")
    .each(function () {
      var varID = $(this).attr("data-productminid");

      var next_qty = $(this).find(".quantity-selector__value").attr("data-input");
      var minus_qty = $(this).find(".minus-qty").attr("data-quantity");
      console.log(next_qty, 'hello');

      var qtyInput = parseInt(next_qty) - parseInt(minus_qty);
        if(qtyInput >= next_qty){
        var qtyNum = 1;
      }else{
        var qtyNum = parseInt(next_qty / qtyInput);
      }

      $(".product-item .product-id").each(function () {
        var colId = $(this).attr("data-productid");
      
        if (varID == colId) {
          $(this).find(".product-item__action-list").find("#qtn2").val(qtyNum);
        }
      });
    }); 
} 
 
    $("button[data-layout-mode='table']").on("click", function() {
              processProductItemsTable();
    });

    $( document ).ready(function() {
    console.log( "ready! df" );
    processProductItemsTable();
});




function processProductItems() {
  $(".mini-cart__line-item-list")
    .find(".mini-cart__line-item")
    .each(function () {
      var varID = $(this).attr("data-productminid");

      var next_qty = $(this).find(".quantity-selector__value").attr("data-input");
      var minus_qty = $(this).find(".minus-qty").attr("data-quantity");

      var qtyInput = parseInt(next_qty) - parseInt(minus_qty);
      if(qtyInput >= next_qty){
        var qtyNum = 1;
      }else{
        var qtyNum = parseInt(next_qty / qtyInput);
      }
      
      $(".product-item .product-id").each(function () {
        var colId = $(this).attr("data-productid");
        if (varID == colId) {
          $(this).find(".product-order-type-qty").find(".quantity-selector__value").val(qtyNum);
        }
      });
    });
}

// Call the function to execute the logic
processProductItems();
//     $('.qty_input').on('change keyup', function() {
//       var usize = $(this).parent('form').parent('.table-qty').parent('.table-data').data('usize');
//       var cqty = $(this).val();
//       var total_qty = usize * cqty;      
//       $(this).parent('form').find('.col-qty').val(total_qty);
//       $(this).parent('form').parent('.table-qty').parent('.table-data').find('.table-tunite').html(total_qty);
//       var colprice = $(this).parent('form').parent('.table-qty').parent('.table-data').find('.table-uprice').find('span').html();      
//       var colpprice = colprice.replace(/[_\W]+/g, "");

// //       if(typeof BOLD === "object" && typeof BOLD.pre === "object" && typeof BOLD.pre.getProductByVariantId === "function"){
// //         var prodId = parseInt(this.form.id.value);
// //         var product = BOLD.pre.getProductByVariantId(prodId);
// //         if(product)
// //           var colpprice = product.price;
// //       }
// //       alert(colpprice);
//       var totalprice = (total_qty*colpprice)/100;
//       var convertprice = totalprice.toFixed(2);  
//       var addsymbole = '$' + convertprice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");      
//       $(this).parent('form').parent('.table-qty').parent('.table-data').find('.piece-total').html(addsymbole);    
//     });
    
//     // Reusable Function to Enforce MaxLength
// function enforce_maxlength(event) {
//   var t = event.target;
//   if (t.hasAttribute('maxlength')) {
//     t.value = t.value.slice(0, t.getAttribute('maxlength'));
//   }
// }

// // Global Listener for anything with an maxlength attribute.
// // I put the listener on the body, put it on whatever.
// document.body.addEventListener('input', enforce_maxlength);

// function processProductItemsTable() {
//   $(".mini-cart__line-item-list")
//     .find(".mini-cart__line-item")
//     .each(function () {
//       var varID = $(this).attr("data-productminid");

//       var next_qty = $(this).find(".quantity-selector__value").attr("data-input");
//       var minus_qty = $(this).find(".minus-qty").attr("data-quantity");

//       var qtyInput = parseInt(next_qty) - parseInt(minus_qty);
//         if(qtyInput >= next_qty){
//         var qtyNum = 1;
//       }else{
//         var qtyNum = parseInt(next_qty / qtyInput);
//       }

//       $(".product-item .product-id").each(function () {
//         var colId = $(this).attr("data-productid");
      
//         if (varID == colId) {
//           $(this).find(".product-item__action-list").find("#qtn2").val(qtyNum);
//         }
//       });
//     }); 
// } 
 
//     $("button[data-layout-mode='table']").on("click", function() {
//         processProductItemsTable();
//     });

// processProductItemsTable();
    
// function processProductItems() {
//   $(".mini-cart__line-item-list")
//     .find(".mini-cart__line-item")
//     .each(function () {
//       var varID = $(this).attr("data-productminid");

//       var next_qty = $(this).find(".quantity-selector__value").attr("data-input");
//       var minus_qty = $(this).find(".minus-qty").attr("data-quantity");

//       var qtyInput = parseInt(next_qty) - parseInt(minus_qty);
//       if(qtyInput >= next_qty){
//         var qtyNum = 1;
//       }else{
//         var qtyNum = parseInt(next_qty / qtyInput);
//       }
      
//       $(".product-item .product-id").each(function () {
//         var colId = $(this).attr("data-productid");
//         if (varID == colId) {
//           $(this).find(".product-order-type-qty").find(".quantity-selector__value").val(qtyNum);
//           // alert(qtyNum);
//         }
//       });
//     });
// }

// // Call the function to execute the logic
// processProductItems();
//   });


var storeCurrencySymbol = $('.store_currency_symbol').attr('data-currency');
/* custom add to cart product plus-minus */

        // Function to show the pop-up
        function showCartLimitPopup() {

            var popupHtml = '<div id="cart-limit-popup" style="width: 350px; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); padding: 30px; background: white; border: 1px solid #ccc; z-index: 1000;">' +
                            '<p>You have reached 300 items. Please proceed to checkout and complete another transaction.</p>' +
                  
                            '<a href="/cart" id="cart-button" style="display: flex;justify-content: center; width:100%;padding: 10px 20px; background: #00badb; color: #fff; border: none; cursor: pointer;">View Cart</a>' +
                            '</div>' +
                            '<div id="popup-overlay" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 999;"></div>';

            // Append the popup to the body
            $('body').append(popupHtml);

            // Add event listener to the checkout button
            $('#cart-button').on('click', function() {
                window.location.href = '/cart';
            });
        }
                 //'<button  onclick="closePopup()" class="close-button-m" style="position: absolute;top: -12px;right: 10px;background-color: transparent;border: none;font-size: 32px;cursor: pointer;">x</button>'+ 
 function closePopup() {
         var cartLimitPopup = document.getElementById('cart-limit-popup').remove();
      var popupOverlay = document.getElementById('popup-overlay').remove();
 
    }

    // Attach the closePopup function to the button's onclick event
    // var click = document.getElementById('close-button').onclick = closePopup;


$(document).on('click', '.product_custom_add.active .custom_qty_plus',function(e){
  e.preventDefault();
  $('.loading-bar').addClass('is-visible');
  $('.loading-bar').css('transform', 'scaleX(0.4)');
  $(this).prop("disabled", true);
  $(this).next(".custom_qty_minus").prop("disabled", true);
  var headerCount = $('.header__cart-count'); 
  // var totalProduct = window.routes.cartItemcount
  var th = $(this).parents('.product_custom_add').find('.qty');  
  // var proQty = $(this).parents('.product_custom_add').find('.product_order_type_qty').data('finalqty');
  th.val(+th.val() + 1);

  // var cartTotal = (parseInt(totalProduct)+parseInt(proQty));
  
  // totalProduct.val()
  
      
  $this = $(this);

  customProductAddCart($this);

checkCartQuantity();
  priceUpdate($this);
// setTimeout (
//   function(){
//    $(headerCount).text(cartTotal);
// },4000);
  
});

$(document).on('click', '.product_custom_add.active .custom_qty_minus', function(e) {
  e.preventDefault();

  // Add loading-bar styles
  $('.loading-bar').addClass('is-visible').css('transform', 'scaleX(0.4)');
  $(this).prop("disabled", true);
  $(this).prev(".custom_qty_plus").prop("disabled", true);
  // Decrease the value of the input field with class .qty
  var th = $(this).parents('.product_custom_add').find('.qty');
  if (th.val() > 0) th.val(+th.val() - 1);

  // Perform other actions
  var $this = $(this);
  customProductAddCart($this);

  checkCartQuantity();
  priceUpdate($this);
  $this.parents('.product_order_type_selector').find('.product_order_type_qty.product-order-type-qty').removeClass('pointer-events-none');
  $this.parents('.product_order_type_selector').find('.product_order_type_qty .custom_qty_plus').removeClass('pointer-events-none');
  $this.parents('.product-item--table').find('.table-qty .custom_qty_plus').removeClass('pointer-events-none');
  $this.parents('.product-item--table').find('.table-qty .qty_input').removeClass('pointer-events-none');
 
});

// $(document).on('click', '.custom_table_data  .custom_qty_plus', function(e) {

//  var th12 = $(this).parents('.table-qty').find('.qty.dada');  
//   // var proQty = $(this).parents('.product_custom_add').find('.product_order_type_qty').data('finalqty');
//   th12.val(+th12.val() + 1);
//   alert($(this).parents('.table-qty').html());
//   var $this = $(this);
// priceUpdatetableview($this);
// });

$(document).on('click', '.custom_table_data .custom_qty_plus', function(e){
  e.preventDefault();
  
  var $input = $(this).parents('.custom_table_data').find('.table-qty .qty_input');
  $input.val(parseInt($input.val()) + 1);
  $input.change();
  $this = $(this);
  priceUpdatetableview($this);
   $this.parents('.custom_product_id').find('.product_custom_add.active .custom_qty_plus').click();
});

$(document).on('click', '.custom_table_data .custom_qty_minus', function(e){
  e.preventDefault();

  var $input = $(this).parents('.custom_table_data').find('.table-qty .qty_input');
  var count = parseInt($input.val()) - 1;
  count = count < 1 ? 0 : count;
  $input.val(count);
  $input.change();
  $this = $(this);
  priceUpdatetableview($this);
  $this.parents('.custom_product_id').find('.product_custom_add.active .custom_qty_minus').click();

});

function priceUpdatetableview($this) {
  var quantity = parseFloat($this.parents('.table-qty').find('.qty').val() || 1);
   var pricePerUnit = parseFloat($this.parents('.table-qty').attr('data-price'));
  var finalqty = parseFloat($this.parents('.table-qty').attr('data-finalqty'));
  var finalQtyPrice = (quantity * pricePerUnit) * finalqty;
   var finalQty = quantity * finalqty;
   $this.parents('.table-qty').find('.table-tunite').text(finalQty);
   $this.parents('.custom_table_data').find('.table-totle  .money_total_product').text(storeCurrencySymbol + finalQtyPrice.toFixed(2));
}

function priceUpdate($this) {
  var quantity = parseFloat($this.parent('.product_order_type_qty').find('.qty').val() || 1);
  var pricePerUnit = parseFloat($this.parent('.product_order_type_qty').attr('data-price'));
  var finalqty = parseFloat($this.parent('.product_order_type_qty').attr('data-finalqty'));
  var finalQtyPrice = (quantity * pricePerUnit) * finalqty;
  
  var finalQty = quantity * finalqty;
  console.log(finalQtyPrice, quantity,  finalqty, 'update price');
  $this.parents('.product_order_type_selector').find('.total_price_changes .totle_price_bar .piece_qty').text(finalQty);
  console.log($this.parents('').parents('.table-qty').html());
  $this.parents('.product_order_type_selector').find('.total_price_changes .money_total_product').text(storeCurrencySymbol + finalQtyPrice.toFixed(2));
}
function checkCartQuantity() {
    var headerCounts = parseInt($('.header__cart-count').text(), 10);
    // var headerCounts = $('.data_item_size_cart').data('item-size');
 console.log(headerCounts,"headerCounts");
    if(headerCounts >= 299){
      setTimeout(function() {
           showCartLimitPopup();
      }, 800);
   
    }
     if(headerCounts  == 300){
           setTimeout(function() {
           showCartLimitPopup();
      }, 800);
    }
  
}




setTimeout(function() {
  var headerCountst = $('.header__cart-count').text();
// console.log(headerCountst,"headerCountst");
      if(headerCountst >= 300){
          if (window.location.pathname !== '/cart') {
      showCartLimitPopup();
          }
    }
}, 800);


// $(document).on('click', '.line-item__quantity-remove ',function(e){
//   e.preventDefault();
//   $('.loading-bar').addClass('is-visible');
//   $('.loading-bar').css('width', '40%');
//    setTimeout(function() {
//   var text = document.querySelector('.header__cart-counts').textContent;
//       // var text = document.querySelectorAll('tbody .line-item--stack').length;

//   if(text > 0) {
//     var parElement = document.querySelector(".header__cart-counts");
//     var new_count_value = text - 1;
//     var textToAdd = document.createTextNode(new_count_value);
//      parElement.replaceChildren(new_count_value);
//   }

//   $this = $(this);
//   customProductAddCart($this);
//       // const lineItemsCount = $('tr.line-item.line-item--stack').length;
//       // console.log(lineItemsCount);
//   }, 600);

// });
// $(document).on('click', '.quantity-selector__button-1.decrease',function(e){
//   e.preventDefault();
//   $('.loading-bar').addClass('is-visible');
//   $('.loading-bar').css('width', '40%');
//    setTimeout(function() {
//   var text = document.querySelectorAll('tbody .line-item--stack').length;
//   if(text > 0) {
//     var parElement = document.querySelector(".header__cart-counts");
//     var new_count_value = text - 1 ;
//     var textToAdd = document.createTextNode(new_count_value);
//      parElement.replaceChildren(new_count_value);
//   }
//   $this = $(this);
 
//      customProductAddCart($this);
//   }, 100);

// });



function customProductAddCart($this){
  var currentVariantId = $this.parents('.product_custom_add').find('.ProductId').val();
  var dataFinalQty = $this.parents('.product_custom_add').find('.product_order_type_qty').attr('data-finalqty');
  var dataCartkey = $this.parents('.product_custom_add').find('.product_order_type_qty').attr('data-key');
  //alert(dataFinalQty);
  var prevdataFinalQty = $this.parents('.product_custom_add').prev('.product_custom_add').find('.product-order-type-qty').find('input').val() || 0;
  var dataPk = $this.closest('.product_custom_add').find('.product_order_type_qty').attr('data-pk');
  if(prevdataFinalQty > 0){
    dataPk = 'pk';
    var csCartKeyupdate = $this.parents('.product_custom_add').prev('.product_custom_add').find('.product-order-type-qty').attr('data-key');
    $this.parents('.product_custom_add').find('.product_order_type_qty').attr('data-key', csCartKeyupdate);
  }
  // var dataStockQty = $this.parents('.product_custom_add').find('.product_order_type_qty').attr('data-stockqty');
  var totalQtyInput = $this.parents('.product_custom_add').find('.product_order_type_qty .qty').val();
  //var currentVariantQty = totalQtyInput * dataFinalQty;
  
  if($this.hasClass("custom_qty_minus")){
    var minusInputQty = $this.parents('.product_custom_add').find('.product_order_type_qty').find('.qty').val();
    //var case_pk = $(this).parents('.product_custom_add').prev('.product_custom_add').find(".product_order_type_qty").eq(1).find('.qty').val();
    if(prevdataFinalQty == 0){
      var temp = $this.parents('.product_custom_add').next('.product_custom_add').find('.product_order_type_qty').find('input').val() || 0;
      var temp1 = $this.parents('.product_custom_add').next('.product_custom_add').find('.product_order_type_qty').attr("data-finalqty");
      prevdataFinalQty = temp * temp1;
      if (isNaN(prevdataFinalQty)) {
        prevdataFinalQty = 0;
      }
    }
    console.log(prevdataFinalQty);
    //alert(minusInputQty);
    console.log(dataFinalQty);
    let dataPknew = $this.closest('.product_custom_add')
    .find('.product_order_type_qty')
    .attr('data-pk');
    var newQty = parseFloat(prevdataFinalQty) + (minusInputQty * dataFinalQty);
    
// fetch('/cart.js')
//   .then(res => res.json())
//   .then(cart => {
//     // cart.items is an array
//     cart.items.forEach(item => {
//       console.log(dataPk,currentVariantId);
//       console.log("Product ID: " + item.variant_id, item.quantity);
//       // You can also log properties if needed
//       console.log("Properties:", item.properties);
//     });
//   });
        //alert(dataPk);
fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    let hasCS = cart.items.some(item =>
      item.variant_id == currentVariantId &&
      item.properties &&
      item.properties["_Case Handling"] === 'cs'
    );
    cart.items.forEach(item => {
 if (item.variant_id == currentVariantId) {
 if (!hasCS) {
  // If "cs" not available for this variant → use calculated qty
  let currentVariantQty = parseFloat(prevdataFinalQty) + (minusInputQty * dataFinalQty);
  // Find the PK product in cart
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const pkItem = cart.items.find(item =>
        item.variant_id == currentVariantId &&
        item.properties &&
        item.properties["_Case Handling"] === "pk"
      );

      if (pkItem) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: pkItem.key,                    // ✅ must use line item key
            quantity: parseInt(currentVariantQty) // new quantity
          })
        })
          .then(res => res.json())
          .then(updatedCart => {
            console.log('Cart updated:', updatedCart);
            console.log("Updated PK Properties:", pkItem.properties);
            // location.reload(); // if you want refresh
          })
          .catch(err => console.error('Error updating cart:', err));
      } else {
        console.log('No PK item found for this variant.');
      }
    });
}
        if (parseFloat(minusInputQty) === 0 && parseFloat(prevdataFinalQty) > 1) {
          //alert('0');
          $this.parents('.product_custom_add')
            .next('.product_custom_add')
            .find('.product_order_type_qty input')
            .val(0);
          fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      cart.items.forEach(item => {
        if (
          item.variant_id == currentVariantId &&
          item.properties &&
          (item.properties["_Case Handling"] === "cs" || item.properties["_Case Handling"] === "pk")
        ) {
          // Remove the item from cart
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0 // 0 means remove
            })
          })
            .then(res => res.json())
            .then(updatedCart => {
              console.log('Removed item:', item, updatedCart);
            })
            .catch(err => console.error('Error removing item:', err));
        }
      });
    });
        }
 }

      // Match by variant ID + property "_Case Handling"
      if (item.variant_id == currentVariantId && item.properties && item.properties["_Case Handling"] == dataPknew) {
        // Update cart with new quantity
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: item.key,          // line item key (unique identifier)
            quantity: parseInt(minusInputQty) // new quantity
          })
        })
          .then(res => res.json())
          .then(updatedCart => {
            console.log('Cart updated:', updatedCart);
            // Optional: reload or re-render cart page
            console.log("Properties:", item.properties);
            //location.reload(); 
          })
          .catch(err => console.error('Error updating cart:', err));
      }
    });
  });

      
      // let currentVariantQty;
    // if (parseFloat(minusInputQty) === 0 && parseFloat(prevdataFinalQty) > 1) {
    //     currentVariantQty = 0;
    //     $this.parents('.product_custom_add')
    //         .next('.product_custom_add')
    //         .find('.product_order_type_qty input')
    //         .val(0);
    //         alert('if');
    // } else {
    //   alert('else');
    //     currentVariantQty = parseFloat(prevdataFinalQty) + (minusInputQty * dataFinalQty);
    //     //alert(currentVariantQty);
    // }
    // //var currentVariantQty = parseFloat(prevdataFinalQty) + (minusInputQty * dataFinalQty);
    // alert(currentVariantQty, dataCartkey);
     var url ="/cart/update.js"
    // var dataForm = `&updates[${dataCartkey}]=${currentVariantQty}`;
    // console.log(dataForm);
  }else{
    var currentVariantQty = dataFinalQty;
    var url ="/cart/add.js";
    var dataForm = {
          id: parseInt(currentVariantId),
          quantity: parseInt(currentVariantQty),
          properties: {
            "_Case Handling": dataPk,
          }
        };
  }
  

  //let dataForm = `&updates[${currentVariantId}]=0`;
  setTimeout(function() {
    $('.loading-bar').css('transform', 'scaleX(1)');
  }, 100);

  // $.ajax({
  //   type: "POST",
  //   url: "/cart/update.js",
  //   data: dataForm,
  //   dataType: "json",
  //   success: function (response) {
      
      jQuery.ajax({
        type: "POST",
        url: url,
        data: dataForm,
        dataType: "json",
        success: function (result) {

          // out of stock event none

        // var event_none = (dataStockQty - dataFinalQty);
 

          
          // end out of stock none
          
          productPrice = $this.parents('.product_order_type_selector').find('.total_price_changes .piece_price').attr('data-price');
           productQty = $this.parents('.product_order_type_selector').find('.product_order_type_qty.product-order-type-qty').attr('data-stockqty');
          var event_none = (productQty - dataFinalQty);

                  if(event_none == 0){
                       $this.parents('.product_order_type_selector').find('.product_order_type_qty.product-order-type-qty').addClass('pointer-events-none');
                        $this.parents('.product_order_type_selector').find('.product_order_type_qty .custom_qty_plus').addClass('pointer-events-none');
                    $this.parents('.product-item--table').find('.table-qty .custom_qty_plus').addClass('pointer-events-none');
                    $this.parents('.product-item--table').find('.table-qty .qty_input').addClass('pointer-events-none');
                }else{
      
                    $this.parents('.product_order_type_selector').find('.product_order_type_qty.product-order-type-qty').removeClass('pointer-events-none');
                    $this.parents('.product_order_type_selector').find('.product_order_type_qty .custom_qty_plus').removeClass('pointer-events-none');
                    $this.parents('.product-item--table').find('.table-qty .custom_qty_plus').removeClass('pointer-events-none');
                    $this.parents('.product-item--table').find('.table-qty .qty_input').removeClass('pointer-events-none');

                }
          // alert(event_none);
          //$this.parents('.product_order_type_selector').find('.total_price_changes .totle_price_bar .piece_qty').text(result.quantity);
          var totalPrice = (result.final_line_price/100);
          console.log("result", result);
          if(currentVariantQty == 0){
             alert(dataFinalQty * productPrice);
           var totalPrice = (dataFinalQty * productPrice);
          }
          //$this.parents('.product_order_type_selector').find('.total_price_changes .money_total_product').text(storeCurrencySymbol + totalPrice);
          //$this.parents('.product-item--table').find('.custom_table_data.table-data .table-totle .money_total_product').text(storeCurrencySymbol + totalPrice);
          
          $('.loading-bar').removeClass('is-visible');
          $('.loading-bar').css('transform', 'scaleX(0)');
          $('.custom_qty_plus').prop("disabled", false);
          $('.custom_qty_minus').prop("disabled", false);
          // console.log(window.routes.cartItemcount);
          custom_mini_cart();
        },
        error: function () {
          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              id: parseInt(currentVariantId),
              quantity: parseInt(currentVariantQty)
            },
            dataType: "json",
            success: function (result) {
              //console.log(result);
              $('.loading-bar').removeClass('is-visible');
              $('.loading-bar').css('transform', 'scaleX(0)');
              custom_mini_cart();
            }
          });
        }
      });
      var currentPath = window.location.pathname;

// Check if currentPath contains "collection"
if (currentPath.includes('collection')) {
  $.ajax({
    url: currentPath,
    type: 'GET',
    success: function (data) {
      var newContent = $(data).find('#card-total').html();
      $('#card-total').html(newContent); // or .append(newContent)
    },
    error: function (xhr, status, error) {
      console.error("Failed to load #card-total from current URL:", status, error);
    }
  });
}

  //   }
  // });
}

$(document).on('click', '.product_order_type_selector .product_custom_add [type="radio"]', function(){  
  var parents = $(this).parents('.product_order_type_selector');
  parents.find('.product_custom_add.active [type="radio"]').prop('checked', false);
  parents.find('.product_custom_add').removeClass('active');
  $(this).parents('.product_custom_add').addClass('active');
  
  var dataFinalQty = $(this).parents('.product_custom_add').find('.product_order_type_qty').attr('data-finalqty');
  parents.find('.total_price_changes .piece_qty').text(dataFinalQty);
});


// // binding
// // $(document).on('click', '.product-item--table .custom_table_data .custom_qty_minus', function(e){
// //   e.preventDefault();

// //   var $input = $(this).parents('.custom_table_data').find('.table-qty .qty_input');
// //   var count = parseInt($input.val()) - 1;
// //   count = count < 1 ? 1 : count;
// //   $input.val(count);
// //   $input.change();

// //   $this = $(this);
// //   $this.parents('.custom_product_id').find('.product_custom_add.active .custom_qty_minus').click();
  
// // });

function custom_mini_cart(){
  var url = `/?section_id=custom_mini_cart`;
  $.ajax({
    url: url,
    success: function(data) {
      const html = new DOMParser().parseFromString(data, "text/html");
      var mainContentElement = html.getElementById('mini-cart');
      if (mainContentElement) {
        var product_html_new = mainContentElement.innerHTML;
        document.getElementById('mini-cart').innerHTML = product_html_new;
        var cartCount = $(document).find('.data_item_size_cart').attr('data-item-size');
        $(document).find('.header__cart-count')?.text(cartCount); 

        cartKeyUpdate();
        
        //$('.header__action-item-link.header__cart-toggle')[0]?.click();
      } else {
        console.error("Element with ID 'mainContentElement' not found in the returned HTML");
      }
    }
  });
}


//  //   jQuery(document).ready(function(){
//  //  document.querySelector('.product-form__payment-container').addEventListener('click', handleCartClicke);
      
//  //  function handleCartClicke(e){
//  //     var varproID3 = $(".quantity-selector__value").attr("data-line-id");
//  //    setTimeout(function() {
//  //   var colproId3 = $(".product-form__info-list").attr("data-proid");
//  //   var text3 = document.querySelector('.header__cart-counts').textContent;
//  //     if (varproID3 != colproId3) {
//  //              var parElement = document.querySelector(".header__cart-counts");
//  //              var new_count_value1 = Number(text3) + 1;
//  //              var textToAdd1 = document.createTextNode(new_count_value1);
//  //               parElement.replaceChildren(new_count_value1); 
//  //        }
//  //     },100);
//  //    };
//  // });


//  jQuery(document).ready(function(){

//   $(".mini-cart__line-item-list")
//     .find(".mini-cart__line-item")
//     .each(function () {
//       var varproID = $(this).attr("data-productminid");
//       var nextpro_qty = $(this).find(".quantity-selector__value").attr("data-input");
//       var minuspro_qty = $(this).find(".minus-qty").attr("data-quantity");

//       var qtyproInput = parseInt(nextpro_qty) - parseInt(minuspro_qty);
//       var qtyproNum = parseInt(nextpro_qty / qtyproInput);

   
//         var colproId = $(".product-form__info-list").attr("data-proid");

//         if (varproID == colproId) {
//           $(".product-order-type-selector").find(".pck-qty").find("input").val(qtyproNum);    
//         }
     
//     });

  
//  });

function cartKeyUpdate() {
  // alert("cartKeyUpdate");
  $(".mini-cart__line-item-list")
    .find(".mini-cart__line-item")
    .each(function () {
      var varID = $(this).attr("data-productminid");
      var case_pk = $(this).attr("data-pk");
      var cartKey = $(this).attr("data-key");
      $(".product-item").find(".product-id").each(function () {
          var colId = $(this).attr("data-productid");
          if (varID == colId) {
             if(case_pk == 'pk'){
               $(this).find(".product-order-type-qty").attr('data-key', cartKey);
             }else{
               $(this).find(".product_order_type_qty").attr('data-key', cartKey);
             }
            //
          }
        });
    });
}
function processProductItems() {
  $(".mini-cart__line-item-list")
    .find(".mini-cart__line-item")
    .each(function () {
      var varID = $(this).attr("data-productminid");
      var case_pk = $(this).attr("data-pk");
      var next_qty = $(this).find(".quantity-selector__value").val();
      var cartKey = $(this).attr("data-key");
      var minus_qty = $(this).find(".minus-qty").attr("data-quantity");
      var qtyInput = parseInt(next_qty - minus_qty);
      var qtyNum = parseInt(next_qty / qtyInput);
      $(".product-item").find(".product-id").each(function () {
          var colId = $(this).attr("data-productid");
          if (varID == colId) {
             if(case_pk == 'pk'){
                $(this).find(".product-order-type-qty").find("input").val(qtyNum); 
               $(this).find(".product-order-type-qty").attr('data-key', cartKey);
             }else{
               var case_cs = $(this).find(".product_order_type_qty").eq(1).attr('data-finalqty');
               var case_cs_num = parseFloat(case_cs);
                var qtyNum_num = parseFloat(qtyNum);
               var final_cs = qtyNum_num / case_cs_num;
               $(this).find(".product_order_type_qty").find("input").val(final_cs);
               $(this).find(".product_order_type_qty").attr('data-key', cartKey);
             }
            //
          }
        });
    });
}

// Call the function to execute the logic
//processProductItems();



